import { Link } from 'wouter';
import BookingForm from '../components/BookingForm.js';

const Booking = () => {
  return (
    <div className="container mx-auto px-4 pt-8" style={{ marginTop: '20px' }}>
      <div className="max-w-4xl mx-auto">
        {/* Breadcrumb Navigation */}
        <nav className="mb-6 p-4 bg-gradient-to-br border border-green-300 rounded" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2 text-sm text-gray-600">
            <li>
              <Link href="/" className="hover:text-primary transition-colors">
                Home
              </Link>
            </li>
            <li className="flex items-center">
              <span className="mx-2">/</span>
              <span className="text-gray-900 font-medium">Booking</span>
            </li>
          </ol>
        </nav>
      </div>
      
      <section id="booking" className="bg-gradient-to-br from-primary/10 to-blue-50 min-h-screen flex items-center justify-center py-16">
        <div className="container mx-auto px-4 w-full">
          <div className="bg-white shadow-2xl rounded-2xl overflow-hidden max-w-4xl mx-auto">
            <div className="p-6 md:p-12 bg-white">
              <div className="text-center mb-8">
                <h2 className="text-3xl md:text-4xl font-extrabold text-primary mb-4 tracking-tight">
                  Book Your Device Repair
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Fast, reliable repair service. We'll confirm your appointment within 2 hours.
                </p>
              </div>
              
              <BookingForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Booking;
